<div
	class="para-student-badge tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"
	role="img"
	[attr.aria-label]="ariaLabel"
>
	<app-para-milestone-icon
		class="tw-h-full tw-w-full"
		[tier]="displayMilestoneTier"
		[svgClass]="milestoneGlyphSvgClass"
		[style.color]="milestoneOverlayGlyphColor"
		aria-hidden="true"
	></app-para-milestone-icon>
</div>
